module.exports = __webpack_public_path__ + "static/assets/8d4e8bbfc1590b6a06e5909c2afdb60d.svg";